<template>
    <div>
      
        <Content :style="{padding: '24px',marginBottom:'24px',minHeight: '480px', background: '#fff'}">
            <el-form ref="waybill" label-position="right" label-width="80px" :model="waybill" inline>
                <el-form-item label="站点选择" prop="shopId">
                    <!--  <el-select v-model="waybill.shopId" placeholder="站点选择">
                        <el-option v-for="(st,ind) in shopTypes " :value="ind" :key="ind">
                          {{st}}{{ind}}
                        </el-option>
                    </el-select>-->
                    <el-select v-model="waybill.shopId" placeholder="站点选择">
                        <el-option v-for="(st,ind) in shopTypes " :key="ind" :value="ind" disabled>
                            {{st}}
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单号" prop="orderId">
                    <el-input size="small" v-model="waybill.orderId" placeholder="订单号" style="width: 240px" readonly />
                </el-form-item>
                <el-form-item label="货运单号" prop="waybillOrder">
                    <el-input size="small" v-model="waybill.waybillOrder" placeholder="货运单号" style="width: 240px" readonly />
                </el-form-item>
                <el-form-item label="包裹数量" prop="packageCount">
                    <el-input size="small" v-model="waybill.packageCount" type="number" readonly placeholder="包裹数量" style="width: 160px;" />
                </el-form-item>
                <el-form-item label="验货类型" prop="insp">
                    <!--  <el-select v-model="waybill.shopId" placeholder="站点选择">
                        <el-option v-for="(st,ind) in shopTypes " :value="ind" :key="ind">
                          {{st}}{{ind}}
                        </el-option>
                    </el-select>-->
                    <el-select v-model="waybill.insp" placeholder="验货类型">
                        <el-option :value=1 :disabled="waybill.id>0" disabled>
                           需要验货
                        </el-option>
                        <el-option :value=0 :disabled="waybill.id>0" disabled>
                           无需验货
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="userRemark">
                    <el-input size="small" v-model="waybill.userRemark" type="textarea" :rows="8" placeholder="备注" style="width:340px" readonly />
                </el-form-item>
                <div>
                    <Tag color="success" v-if="waybill.big==1">大件货</Tag>
                </div>
            </el-form>
            <el-divider>快捷操作</el-divider>
            <div>
                签收进度：
                <Progress :percent="waybill.signCount / waybill.packageCount * 100"></Progress>
                <a :href="waybill.waybillPath" target="_blank">打印面单</a>
                <el-button size="small" type="danger" @click="setBig" v-if="waybill.big ==0" style="margin: 10px;float: right;">
                  设为大件货  <template v-if="waybill.shopId==1">,【店配】</template>

                </el-button>
                <el-button size="small" type="primary" @click="ok" v-if="waybill.state == 2" style="margin: 10px">确定出库</el-button>
                <el-button size="small" type="warning" @click="fouce" v-if="waybill.state==1" style="margin: 10px">强制出库</el-button>
                <el-button size="small" type="warning" style="float: right;margin: 10px" @click=" showGap = true;">补差价</el-button>
            </div>
            <el-divider>快递包裹</el-divider>
            <Table style="margin-top: 30px" :columns="columns" :data="waybillExpresss" border stripe>
            </Table>
        </Content>
        <Modal :title="title" v-model="visible" :width="800">
            <img :src="imgName" v-if="visible" style="width: 100%">
        </Modal>
        <CWaybillBig :show="showBig" @ok="showBig=false;getDetail()" @cancel="showBig=false" :waybillId="waybill.id"></CWaybillBig>
        <CWaybillGap :show="showGap" @ok="showGap=false;getDetail()" @cancel="showGap=false" :waybillId="waybill.id"></CWaybillGap>
    </div>
</template>
<script>
import Constants from "@/utils/constants"
import CWaybillBig from '../Waybill/CWaybillBig.vue'
import CWaybillGap from '../Waybill/CWaybillGap.vue'

import api from "@/api/api"
export default {
    name: 'Waybill',
    data() {
        return {
            showGap: false,
            visible: false,
            imgName: "",
            title: "",
            root: api.root,
            loading: false,
            modalLoading: false,
            showAdd: false,
            modalEdit: false,
            showBig: false,
            shopTypes: Constants.shopTypes,
            waybillExpresss: [],
            waybill: {
                shopId: "1",
                id: 0,
                insp: 0,
                waybillOrder: "",
                waybillPath: "",
                waybillPathImage: "",
            },

            columns: [{
                    title: '快递选择',
                    key: 'expressId',
                    width: 180,
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        var divs = [];
                        if (row.mult == 1) {
                            divs.push(h("div", { style: { color: "#ff0000" } }, "多订单"));
                        }
                        divs.push(h("div", {}, row.expressName));
                        divs.push(h("div", {}, "单号：" + row.expressNo));
                        return h("div", { props: {}, style: {} }, divs);

                    }
                }, {
                    title: '外部订单号（淘宝阿里）',
                    key: 'outOrderNo',
                    width: 190,
                    align: 'center'
                }, {
                    title: '状态',
                    key: 'state',
                    width: 190,
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        var spans = [];
                        var me = this;
                        spans.push(h("div", "创建：" + me.long2datetime(params.row.createTime)));

                        var text = "待签收";
                        var styles = { color: '#fff', padding: '2px' };
                        styles.backgroundColor = "#2db7f5";
                        if (row.state == -1) {
                            text = "已退回";
                            styles.backgroundColor = "#ed4014";
                            spans.push(h("div", "退回：" + me.long2datetime(params.row.cancelTime)));
                        }
                        if (row.state == -2) {
                            text = "已取消";
                            styles.backgroundColor = "#ed4014";
                            spans.push(h("div", "取消：" + me.long2datetime(params.row.cancelTime)));
                        } else if (row.state == 1) {
                            text = "已签收";
                            styles.backgroundColor = "#19be6b";
                            spans.push(h("div", "取消：" + me.long2datetime(params.row.signTime)));
                        }
                        spans.push(h("div", { style: styles }, text));

                        return h("div", { style: { padding: "10px 0px" } }, spans);
                    }
                }, {
                    title: '商品图片',
                    key: 'outOrderNo',
                    width: 280,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        var row = params.row;
                        var divs = [];
                        var divimages = [];
                        var ps = row.pics.split("##");

                        for (var i = 0; i < ps.length; i++) {

                            if (ps[i] != '') {
                                var imgs = [];
                                imgs.push(h("img", {
                                    style: {},
                                    attrs: { src: ps[i] },
                                    on: {
                                        click: (e) => {

                                            var t = e.currentTarget.currentSrc;
                                            me.imgName = t;
                                            me.title = row.expressName + ":" + row.expressNo;
                                            me.visible = true;
                                        }
                                    }
                                }));
                                divimages.push(h("div", { class: ["demo-upload-list"] }, imgs));
                            }
                        }
                        if (divimages.length > 0) {

                            return h("div", { props: {}, style: { float: "left" } }, divimages);
                        } else {
                            return h("div", { props: {}, style: {} }, "暂无图片");
                        }



                    }
                }, {
                    title: '备注',
                    key: 'remark',

                    align: 'center'
                }

            ],
            waybillOrder: null
        };
    },
    mounted: function() {

        this.waybillOrder = this.$route.params.waybillOrder;
        this.getDetail();


    },
    components: {
        CWaybillBig,
        CWaybillGap

    },
    computed: {

    },
    methods: {

        setBig: function() {
            this.showBig = true;
        },
        ok: function() {
            var me = this;
            me.$Modal.confirm({
                title: "提示",
                content: "是否确定出库操作",
                onOk: function() {
                    me.showLoading();
                    me.$http.post("/ware/waybill/doOutgoing.action", { id: me.waybill.id }).then(response => {
                        me.hideLoading();
                        var body = response;
                        if (body.status == 0) {
                            me.getDetail();

                        } else {
                            me.$Message.error("操作异常!" + body.info);
                        }
                    }).catch(error => {
                        me.hideLoading();
                    });
                },
                onCancel: function() {

                }
            });
        },
        fouce: function() {
            var me = this;
            me.$Modal.confirm({
                title: "提示",
                content: "是否强制出库",
                onOk: function() {
                    me.showLoading();
                    me.$http.post("/ware/waybill/fouceOutgoing.action", { waybillId: me.waybill.id }).then(response => {
                        var body = response;
                        me.loading = false;
                        if (body.status == 0) {
                            me.successMessage("出库成功！")
                        } else {
                            me.errorMessage(body.info);
                        }
                        me.hideLoading();

                    }, response => {
                        me.hideLoading();
                    });
                },
                onCancel: function() {

                }
            });



        },
        getDetail: function() {
            if (this.waybillOrder == null || this.waybillOrder == undefined || this.waybillOrder == "") return;
            var me = this;
            me.showLoading();
            me.$http.post("/ware/waybill/show.action", { waybillOrder: me.waybillOrder }).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.waybill = body.obj;
                    me.waybill.shopId = me.waybill.shopId + "";
                    me.waybillExpresss = body.obj.list;
                    me.waybill.list = "";
                }
                me.hideLoading();
            }, response => {
                me.hideLoading();
            });
        }



    }

}
</script>
<style scoped>
</style>